import React, { Component } from 'react';
import { PowerBiDashboardView } from '../../components';
import s from './HostStyles.module.scss';

export default class PowerBiDashboardViewHost extends Component {
    constructor(props) {
        super(props);
        this.state = { foo: 'Foo' };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px', background: '#f6f6f6' }}>
                <PowerBiDashboardView foo={this.state.foo} />
            </div>
        );
    }
}
